import { z } from "zod";

// zod のデフォルトのエラーメッセージを置き換える
// 全てのパターンを網羅できていないけど、メジャーなケースは対応している。
export function configureZodErrorMessages() {
  z.config({
    customError: (issue) => {
      // zodエラーコードごとにメッセージをカスタマイズする
      switch (issue.code) {
        // 型に誤り
        case "invalid_type":
          // undefinedだった場合は未入力判定
          if (issue["received"] === "undefined") {
            return "必須項目です";
          } else {
            return "値に誤りがあります";
          }
        case "too_big":
          switch (issue.origin) {
            case "string":
              return `${issue.maximum}文字以下で入力してください`;
            case "number":
            case "bigint":
              return `${issue.maximum}以下で入力してください`;
            case "date":
              return `${issue.maximum}日以前で入力してください`;
            case "array":
            case "set":
              return `${issue.maximum}つ以下選択してください`;
            default:
              return `最大値を超えています`;
          }
        case "too_small":
          switch (issue.origin) {
            case "string":
              return `${issue.minimum}文字以上で入力してください`;
            case "number":
            case "bigint":
              return `${issue.minimum}以上で入力してください`;
            case "date":
              return `${issue.minimum}日以降で入力してください`;
            case "array":
            case "set":
              return `${issue.minimum}つ以上選択してください`;
            default:
              return `最小値を下回っています`;
          }
        default:
          // Return undefined to use default message
          return undefined;
      }
    },
  });
}
